import * as actions from "./actions";

const initialState = { sidebarIsVisible: false };

export const STATE_KEY = "layout";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_SIDEBAR:
      return { ...state, sidebarIsVisible: !state.sidebarIsVisible };
    default:
      return state;
  }
};

export default reducer;
